import { useCallback, useContext, useEffect, useRef } from "react"
import RegisterableContext from "components/admin/registerable/context"
import { func } from "prop-types"

const ExpirationTimer = ({ onCancel }) => {
  const { registerable: reservation } = useContext(RegisterableContext)
  const expirationTimeout = useRef(null)

  useEffect(() => {
    if (!reservation?.expiresInMs) return

    clearTimeout(expirationTimeout.current)
    expirationTimeout.current = setTimeout(() => {
      alertModal(
        {
          title: "This page has expired",
          type: "info",
          xhrOnCancel: true,
          showCancelButton: true,
          cancelButtonText: "Cancel",
          confirmButtonText: "Start a new registration"
        },
        isConfirm => {
          if (isConfirm) {
            redirectToNewReservation()
          } else {
            onCancel()
          }
        }
      )
    }, reservation.expiresInMs)

    return () => {
      clearTimeout(expirationTimeout.current)
    }
  }, [reservation?.expiresInMs])

  const redirectToNewReservation = useCallback(
    () => Turbolinks.visit(`/signups/${reservation?.eventId}/reservations/new`),
    [reservation?.eventId]
  )

  return null
}

ExpirationTimer.propTypes = {
  onCancel: func.isRequired
}

export default ExpirationTimer
